import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const ErrorMessage = ({ errorText }) => {
  if (errorText) {
    return (
      <small className="form-text invalid-feedback"><FormattedMessage id={errorText} /></small>
    );
  }
  return null;
};

ErrorMessage.defaultProps = {
  errorText: null,
};

ErrorMessage.propTypes = {
  errorText: PropTypes.string,
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/ErrorMessage/ErrorMessage.jsx